export default __webpack_public_path__ + "static/media/india_offshore_wind.bbc518d4.png";